/** Loom — “What Makes Us Different?” (price & plan video card) */
export const LOOM_WHAT_MAKES_US_DIFFERENT_SHARE =
  'https://www.loom.com/share/36c7f96d2c684443b0f0a95c2f9bb436?sid=cb13891b-b6d3-4d6d-8ea7-e480e27332c7';

/** Same video, embed URL for iframe `src` (Loom share links are not valid HTML5 video sources). */
export const LOOM_WHAT_MAKES_US_DIFFERENT_EMBED =
  'https://www.loom.com/embed/127a5409047d4dd59df9443e8fd70574';

export const LOOM_WHAT_FULL_DEMO =
  'https://www.loom.com/embed/127a5409047d4dd59df9443e8fd70574';

export const LOOM_CREDIT_USAGE_GUIDE_EMBED =
  'https://www.loom.com/embed/bba4f364baa844ba8994d29aed2d282c';

/** AI ARK demo MP4 used in the Credit Usage overview "Watch the Video" modal. */
export const CREDIT_USAGE_DEMO_MP4 =
  'https://ai-ark.com/wp-content/uploads/2024/05/Demo-page-AI-ARK-Final.mp4';

/**
 * Ambient looping clip used as the background of the Credit Usage "Watch the
 * Video" card. Hosted on S3 rather than bundled as a local asset so it stays
 * out of the app build.
 */
export const CREDIT_USAGE_ONBOARD_BG_MP4 =
  'https://s3.ai-ark.com/video/redpandacompress_onboard%20%281%29.mp4';

/**
 * Poster for the ambient clip above — the video's own first frame, extracted
 * and compressed to a small JPEG. Served from the shared static assets so it is
 * fetched immediately (unlike the S3 mp4, which is held by `preload="none"`).
 * Gives the card a real visual fallback when autoplay is blocked and removes any
 * flash during the idle wait before playback starts.
 */
export const CREDIT_USAGE_ONBOARD_BG_POSTER =
  '/assets/images/credit-usage-onboard-poster.jpg';
/** Loom — shown before confirming a downgrade to the Free plan. */
export const LOOM_DOWNGRADE_TO_FREE_SHARE =
  'https://www.loom.com/share/e56c8ceb79014cde9f83a2eb229c4d32';
